const config = {
    apiAddress: 'https://www.newwebinar.ir/api/',
    // apiAddress: 'http://127.0.0.1:8000/api/',
}


export default config

